export default "__VITE_ASSET__f10108cf__"